import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '__app/spacing';
import { KizenTypography } from '__app/typography';
import { MobileContainer } from './styles';
import { PropsWithChildren } from 'react';

export const WithMobileWarning = ({ children = null }: PropsWithChildren) => {
  const { t } = useTranslation();
  const mobileDisplay = useBreakpoint();

  return mobileDisplay ? (
    <MobileContainer>
      <KizenTypography>
        {t(
          'This page has not been optimized for mobile. Please revisit on a desktop to receive the best experience.'
        )}
      </KizenTypography>
    </MobileContainer>
  ) : (
    <>{children}</>
  );
};
